"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ui = require("@alycecom/ui");

var _recipientDetails = require("../../../Shapes/recipientDetails.shape");

var _recipient = require("../../store/recipient/recipient.actions");

var _recipient2 = require("../../store/recipient/recipient.selector");

var _UnsubscribedRecipientConfirmation = _interopRequireDefault(require("../../components/UnsubscribedRecipientConfirmation"));

var _RecipientDetailsForm = _interopRequireDefault(require("./RecipientDetailsForm"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var spacing = _ref.spacing;
  return {
    root: {
      padding: "".concat(spacing(3, 2)),
      margin: spacing(2)
    },
    buttonIcon: {
      marginRight: spacing(1),
      color: 'inherit'
    },
    button: {
      marginTop: spacing(2)
    },
    disabled: {
      pointerEvents: 'none',
      opacity: 0.5
    }
  };
});

var RecipientDetailsEdit = function RecipientDetailsEdit(_ref2) {
  var email = _ref2.email,
      hasInternational = _ref2.hasInternational,
      onClose = _ref2.onClose,
      formProps = (0, _objectWithoutProperties2.default)(_ref2, ["email", "hasInternational", "onClose"]);
  var classes = useStyles();
  var dispatch = (0, _reactRedux.useDispatch)();
  var isLoading = (0, _reactRedux.useSelector)(_recipient2.getRecipientIsLoading);
  var errors = (0, _reactRedux.useSelector)(_recipient2.getRecipientErrors);
  var isUnsubscribed = (0, _reactRedux.useSelector)(_recipient2.gerRecipientIsUnsubscribed);

  var _useState = (0, _react.useState)((0, _recipientDetails.createEmptyRecipient)(email)),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      recipient = _useState2[0],
      setRecipient = _useState2[1];

  var handleChangeField = (0, _react.useCallback)(function (change) {
    return setRecipient(function (currentRecipient) {
      return _objectSpread(_objectSpread({}, currentRecipient), change);
    });
  }, []);
  var handleChangeSearchField = (0, _react.useCallback)(function (fieldName, fieldValue) {
    return setRecipient(function (currentRecipient) {
      return _objectSpread(_objectSpread({}, currentRecipient), {}, {
        [fieldName]: fieldValue
      });
    });
  }, []);
  var handleSubmit = (0, _react.useCallback)(function (e) {
    e.preventDefault();
    dispatch((0, _recipient.createRecipientRequestTry)(recipient, true));
  }, [dispatch, recipient]);
  return /*#__PURE__*/_react.default.createElement(_material.Paper, {
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "H4-Chambray"
  }, "Who\u2019s going to receive this invite to?"), /*#__PURE__*/_react.default.createElement(_RecipientDetailsForm.default, (0, _extends2.default)({
    disabled: isLoading,
    onSubmit: handleSubmit,
    recipient: recipient,
    errors: errors,
    onUpdateSearchField: handleChangeSearchField,
    onUpdateField: handleChangeField,
    hasInternational: hasInternational
  }, formProps, {
    renderActions: function renderActions() {
      return /*#__PURE__*/_react.default.createElement(_material.Grid, {
        container: true,
        justifyContent: "flex-end"
      }, /*#__PURE__*/_react.default.createElement(_material.Button, {
        type: "submit",
        color: "secondary",
        variant: "contained",
        disabled: isLoading,
        className: classes.button,
        onClick: handleSubmit
      }, /*#__PURE__*/_react.default.createElement(_ui.DashboardIcon, {
        icon: "plus",
        color: "primary",
        className: classes.buttonIcon
      }), "Add recipient"));
    }
  })), /*#__PURE__*/_react.default.createElement(_UnsubscribedRecipientConfirmation.default, {
    isOpen: isUnsubscribed,
    email: recipient.email,
    width: 600,
    onSubmit: (0, _react.useCallback)(function () {
      dispatch((0, _recipient.createRecipientSetIsUnsubscribed)(false));
    }, [dispatch]),
    onDiscard: (0, _react.useCallback)(function () {
      dispatch((0, _recipient.createRecipientSetIsUnsubscribed)(false));
      onClose();
    }, [dispatch, onClose])
  })));
};

RecipientDetailsEdit.propTypes = {
  email: _propTypes.default.string,
  hasInternational: _propTypes.default.bool,
  onClose: _propTypes.default.func
};
RecipientDetailsEdit.defaultProps = {
  email: '',
  hasInternational: false,
  onClose: function onClose() {}
};
var _default = RecipientDetailsEdit;
exports.default = _default;